import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../UI/form/MyButton'
import AgreeSelectMain from '../../../../form/fields/AgreeSelectMain'
import { agreeSupplyBillItemEconomistAPI } from '../../../../../api/supply/supplyBillItemAPI'
import { useDispatch } from 'react-redux'
import { editSupplyBillItem, editSupplyBillsItemsAllItem } from '../../../../../store/supplyBillSlice'
import DisagreeTextMain from '../../../../form/fields/DisagreeTextMain'

const AgreeEconomistBillItemForm = ({ supplyBillItemBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(supplyBillItemBd ? {
        isAgreeEconomist: supplyBillItemBd.isAgreeEconomist,
        disagreeEconomistText: supplyBillItemBd.disagreeEconomistText,
    } : {}) // Дані з форми
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()

        setError('')
        setLoading(true)

        agreeSupplyBillItemEconomistAPI({
            id: supplyBillItemBd.id,
            isAgreeEconomist: data.isAgreeEconomist,
            disagreeEconomistText: data.disagreeEconomistText,
        }).then(data => {
            if (data) {
                dispatch(editSupplyBillItem(data))
                dispatch(editSupplyBillsItemsAllItem(data))
                // dispatch(editSupplyBillItemIsAgreeEconomist({
                //     id: data.id,
                //     isAgreeEconomist: data.isAgreeEconomist
                // }))
                // dispatch(setSupplyBillsItemsAllIsAgreeEconomist({ // В окремому списку всіх позицій
                //     id: data.id,
                //     isAgreeEconomist: data.isAgreeEconomist
                // }))
            }

            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div className='myFormSimple'>
        <div>
            <p>
                Погодження позиції в рахунку економістом
            </p>
        </div>
        {
			formDataProductIsField('agree', 'supplyBillItemAgree') ?
				<AgreeSelectMain
					required={formDataProductRequiredField('agree', 'supplyBillItemAgree')}
					setValidate={e => updateValidate(setValid, 'isAgreeEconomist', e)}
					setValueForm={e => setValueForm(setData, 'isAgreeEconomist', e)}
					forciblyValue={
                        data && data.isAgreeEconomist === true ? true :
                        data && data.isAgreeEconomist === false ? false : ''
                    }
				/>
			: ''
        }
        {
			formDataProductIsField('disagreeText', 'supplyBillItemAgree') ?
				<DisagreeTextMain
					// required={formDataProductRequiredField('disagreeText', 'supplierAgree')}
					required={
                        data && (data.isAgreeEconomist === false || data.isAgreeEconomist === 'no') ? true  :
                        formDataProductRequiredField('disagreeText', 'supplyBillItemAgree')
                    }
					setValidate={e => updateValidate(setValid, 'disagreeEconomistText', e)}
					setValueForm={e => setValueForm(setData, 'disagreeEconomistText', e)}
					forciblyValue={data ? data.disagreeEconomistText : ''}
                    className={data && (data.isAgreeEconomist === false || data.isAgreeEconomist === 'no') ? '' : 'hide'}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default AgreeEconomistBillItemForm